import { AppShell, Box, Button, Group, Text, Title } from '@mantine/core';
import { IconLogin } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

export function GuestAmazonLayout({ children }: { children: ReactNode }) {
  const navigate = useNavigate();

  return (
    <AppShell header={{ height: 68 }} padding='xl'>
      <AppShell.Header px={{ base: 'md', sm: 'lg' }}>
        <Group h='100%' justify='space-between'>
          <Group gap='sm'>
            <Box className='brand-mark'>D</Box>
            <div>
              <Title order={3}>Disit</Title>
              <Text size='xs' c='dimmed' visibleFrom='xs'>
                Amazon selling calculator
              </Text>
            </div>
          </Group>
          <Button
            variant='light'
            leftSection={<IconLogin size={18} />}
            onClick={() => void navigate('/login?next=/amazon')}
          >
            Sign in
          </Button>
        </Group>
      </AppShell.Header>
      <AppShell.Main>{children}</AppShell.Main>
    </AppShell>
  );
}
